import { readStored, writeStored } from '@/lib/storage'

export type ConsentChoice = 'necessary' | 'all'

export type ConsentRecord = {
  choice: ConsentChoice
  decidedAt: string
}

export const consentStorageKey = 'partner-space-cookie-consent'

const isChoice = (value: unknown): value is ConsentChoice =>
  value === 'necessary' || value === 'all'

const parseRecord = (raw: string): ConsentRecord | null => {
  try {
    const parsed: unknown = JSON.parse(raw)

    if (typeof parsed !== 'object' || parsed === null) {
      return null
    }

    const candidate = parsed as Partial<Record<keyof ConsentRecord, unknown>>

    if (!isChoice(candidate.choice) || typeof candidate.decidedAt !== 'string') {
      return null
    }

    return { choice: candidate.choice, decidedAt: candidate.decidedAt }
  } catch {
    return null
  }
}

export const readConsent = (): ConsentRecord | null => {
  const raw = readStored(consentStorageKey)
  return raw === null ? null : parseRecord(raw)
}

export const saveConsent = (choice: ConsentChoice, now = new Date()): ConsentRecord => {
  const record: ConsentRecord = { choice, decidedAt: now.toISOString() }
  writeStored(consentStorageKey, JSON.stringify(record))
  return record
}

export const allowsOptionalCookies = (record: ConsentRecord | null): boolean =>
  record !== null && record.choice === 'all'
